import Task from "data.task";
import { curry } from "ramda";

export const toTask = curry((f, x) => Task.of(f(x)));

export const sleep = ms =>
  new Task((_, resolve) => {
    setTimeout(resolve, ms);
  });

export const withRetries = curry((maxRetries, taskReturningFunc) => {
  let retries = 0;

  const retryable = (...args) =>
    taskReturningFunc(...args).orElse(value => {
      if (retries < maxRetries) {
        retries += 1;
        return sleep(1000).chain(() => retryable(...args));
      }

      return Task.rejected(value);
    });

  return retryable;
});

export const forkAsPromise = task =>
  new Promise((resolve, reject) => task.fork(reject, resolve));
